import { render, staticRenderFns } from "./settle.vue?vue&type=template&id=55b7faa8&scoped=true"
import script from "./settle.vue?vue&type=script&lang=js"
export * from "./settle.vue?vue&type=script&lang=js"
import style0 from "./settle.vue?vue&type=style&index=0&id=55b7faa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7faa8",
  null
  
)

export default component.exports